import { ProductTypeEnum, StoreItemEnum } from '@systemeio/digital-store-shared'

export const storeItemTitleLocoKeys: Record<Exclude<StoreItemEnum, 'product'>, string> = {
  [StoreItemEnum.link]: 'dashboard.store.link.title',
  [StoreItemEnum.optin]: 'dashboard.store.optin.title',
  [StoreItemEnum.header]: 'dashboard.store.header.title',
}

export const storeItemProductTitleLocoKeys: Record<ProductTypeEnum, string> = {
  [ProductTypeEnum.download]: 'dashboard.store.product.download.title',
  [ProductTypeEnum.eCourse]: 'dashboard.store.product.e_course.title',
  [ProductTypeEnum.physicalProduct]: 'dashboard.store.product.physical_product.title',
}

export const storeItemProductDescriptionLocoKeys: Record<ProductTypeEnum, string> = {
  [ProductTypeEnum.download]: 'dashboard.store.product.download.description',
  [ProductTypeEnum.eCourse]: 'dashboard.store.product.e_course.description',
  [ProductTypeEnum.physicalProduct]: 'dashboard.store.product.physical_product.description',
}

export const storeItemDescriptionLocoKeys: Record<Exclude<StoreItemEnum, 'product'>, string> = {
  [StoreItemEnum.link]: 'dashboard.store.link.description',
  [StoreItemEnum.optin]: 'dashboard.store.optin.description',
  [StoreItemEnum.header]: 'dashboard.store.header.description',
}
